// ----------------------------------------------------------------
// 2. Hook: hooks/useUpdateBookingComment.ts
// ----------------------------------------------------------------
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../api/api"; // Sesuaikan path jika perlu
import { UpdateBookingCommentType } from "../schema/UpdateBookingCommentSchemaV4";
import { toast } from "sonner";

export const useUpdateBookingComment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: UpdateBookingCommentType;
        }) => {
            // Menggunakan method PATCH untuk update parsial
            const response = await privateApi.patch(
                `/v4/booking/${values.bookingId}/comment`,
                values.formData
            );
            return response.data;
        },
        onSuccess: (_data, variables) => {
            toast.success("Comments updated successfully!");

            // Invalidate query untuk booking yang spesifik agar data di UI ikut terupdate
            queryClient.invalidateQueries({ queryKey: ['booking-show', variables.bookingId] });
        },
        onError: (error: any) => {
            const errorMessage = error?.response?.data?.message || "Failed to update comments";
            toast.error(errorMessage);
            console.error(errorMessage, error.response?.data || error);
            // Error dilempar kembali agar bisa ditangani di level komponen jika perlu
            throw new Error(errorMessage);
        },
    });
};